<template>
  <p class="base-dot">
    &#9642;
  </p>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.base-dot {
  font-size: 1rem;
  color: color(gray-4);
}

</style>
